// extracted by css-extract-rspack-plugin
export default {"cls1":"PremiumUpsellPopover-cls1_6sB","cls2":"PremiumUpsellPopover-cls2_RAM PremiumUpsellPopover-cls1_6sB"};